/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState } from "react";
import useStyles from "./styles";
import ImagesConfig from "components/ImagesConfig";
import InfoPromotion from "./components/InfoPromotion";
import ProductItemFooter from "./components/ProductItemFooter";
import Promotion from "components/Promotion";

import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";
import { Images } from "config/images";

const ProductItem = props => {
	const classes = useStyles();
	const {
		product,
		updateChangeListProduct,
		products,
		carts,
		isConditionPromotion
	} = props;

	const [isWatchPromotion, setWatchPromotion] = useState(false);
	const [idActive, setIdActive] = useState();

	const handleWatchPromotion = id => {
		setWatchPromotion(!isWatchPromotion);
		setIdActive(id);
	};

	return (
		<Grid
			style={{ position: "relative" }}
			classes={{ root: classes.rootProduct }}
		>
			<Promotion
				product={product}
				isConditionPromotion={isConditionPromotion}
			/>
			<Grid container>
				<Grid item xs={4} classes={{ root: classes.images }}>
					<ImagesConfig
						image={product?.image}
						imageDefault={Images.icProductDefault}
						width={80}
						height={80}
					/>
				</Grid>
				<Grid item xs={8} style={{ position: "relative" }}>
					<Grid classes={{ root: classes.infoProduct }}>
						<Grid classes={{ root: classes.nameProduct }} container>
							{product?.name}
						</Grid>
						<Grid container>
							<Grid item xs={6} classes={{ root: classes.price }}>
								Lẻ <span>{formatCash(product?.price)} Đ</span>
							</Grid>
							<Grid item xs={6} classes={{ root: classes.price }}>
								Thùng{" "}
								<span>
									{formatCash(
										product?.price *
											product?.maxUnitQuantity
									)}{" "}
									Đ
								</span>
							</Grid>
						</Grid>
					</Grid>
					<ProductItemFooter
						product={product}
						handleWatchPromotion={handleWatchPromotion}
						updateChangeListProduct={updateChangeListProduct}
						products={products}
						carts={carts}
					/>
				</Grid>
			</Grid>
			{isWatchPromotion && idActive === product?.id && (
				<InfoPromotion product={product} />
			)}
		</Grid>
	);
};
export default memo(ProductItem);
